export default class MsgUtil {
    // 消息-排序-依据guid
    static sortOffLineMsg(msg) {
        msg.sort((start, end) => {
            return start.guid - end.guid; // 排序 guid小的在前
        });
        return msg;
    }
    // 消息-去重-依据guid
    static repeatMsg(msg) {
        let msgArr = this.sortOffLineMsg(msg); // 排序
        let arr = [msgArr[0]];
        for (var index = 1; index < msgArr.length; index++) {
            if (msgArr[index].guid !== msgArr[index - 1].guid) {
                // if (msgArr[index].data !== msgArr[index-1].data) {
                arr.push(msgArr[index]);
                // }
            }
        }
        return arr;
    }
}
//# sourceMappingURL=msgUtil.js.map